import React, {useContext, useState} from "react";
import "./mainHeader.scss";
import {withRouter, RouteComponentProps} from "react-router";
import {useTranslation} from "react-i18next";
import Button from "@mui/material/Button";
import {storesContext} from "../../stores/stores";
import {ReactComponent as IconUser} from "../../../statics/icons/icon_user.svg";
import {ReactComponent as IconAlert} from "../../../statics/icons/icon_notify.svg";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import UserMenu from "./userMenu/userMenu";
import {observer} from "mobx-react";
import NewAlertList from "./newAlertList/newAlertList";
import OwnedVehiclePopup from "../../../vehicleAssigment/components/ownedVehiclePopup/ownedVehiclePopup";

function MainHeader(props: RouteComponentProps): JSX.Element {
    const {t} = useTranslation();
    const userStore = useContext(storesContext).userStore;
    const [isOpenUserMenu, setIsOpenUserMenu] = React.useState(false);
    const [isOpenNewAlertList, setIsOpenNewAlertList] = React.useState(false);
    const anchorRefUserMenu = React.useRef<HTMLButtonElement>(null);
    const anchorRefNewAlertList = React.useRef<HTMLButtonElement>(null);
    const newAlertsCount = userStore.unreadAlertsCount;
    const [displaySelectVehiclePopup, setDisplaySelectVehiclePopup] = useState(false);

    const onClickUserSection = (isOpen: boolean) => {
        setIsOpenUserMenu(isOpen);
    };

    const onClickNewAlertsSection = (isOpen: boolean) => {
        setIsOpenNewAlertList(isOpen);
    };

    return (
        <div className="main-header">
            <div className="title">{getTitle()}</div>
            <div className="actions">
                {userStore.displayAlerts && renderNewAlertsSection()}
                {renderUserSection()}
                {displaySelectVehiclePopup && renderOwnVehiclePopup()}
            </div>
        </div>
    );

    function renderNewAlertsSection() {
        return (
            <div className="new-alerts-section">
                {newAlertsCount > 0 && renderNewAlertsCounter()}
                <Button
                    ref={anchorRefNewAlertList}
                    onClick={() => onClickNewAlertsSection(!isOpenNewAlertList)}
                >
                    <IconAlert className="icon"/>
                </Button>
                <NewAlertList
                    isOpen={isOpenNewAlertList}
                    setOpen={onClickNewAlertsSection}
                    anchorRef={anchorRefNewAlertList}
                />
            </div>
        );
    }

    function renderNewAlertsCounter() {
        return (
            <div className="counter">
                {getNewAlertsCount()}
            </div>
        );
    }

    function renderUserSection() {
        return (
            <div className="user-section">
                <Button
                    ref={anchorRefUserMenu}
                    onClick={() => onClickUserSection(!isOpenUserMenu)}
                >
                    <>
                        <IconUser className="icon"/>
                        {userStore.username}
                        {isOpenUserMenu ?
                            <ExpandLessIcon className="expand-icon" fontSize="small"/> :
                            <ExpandMoreIcon className="expand-icon" fontSize="small"/>
                        }
                    </>
                </Button>
                <UserMenu
                    isOpen={isOpenUserMenu}
                    setOpen={onClickUserSection}
                    anchorRef={anchorRefUserMenu}
                    setDisplaySelectVehiclePopup={setDisplaySelectVehiclePopup}
                />
            </div>
        );
    }

    function renderOwnVehiclePopup() {
        return (
            <OwnedVehiclePopup
                displayPopup={displaySelectVehiclePopup}
                closePopup={() => setDisplaySelectVehiclePopup(false)}
                disabledButtonOnLoadData
            />
        );
    }

    function getTitle() {
        const pathname = props.location.pathname;

        const firstPathName = pathname.split("/")[1];

        switch (firstPathName) {
            case "users":
                return t("administration.title");
            case "transportation":
                if (pathname.split("/")[2] === "ticket") {
                    return t("transportation.ticket.title");
                } else return t("transportation.order.title");
            default:
                if (t(`${firstPathName}.title`).includes(".title")) { // when it is not in the translations
                    return "";
                } else {
                    return t(`${firstPathName}.title`);
                }
        }
    }

    function getNewAlertsCount() {
        return newAlertsCount < 10 ? newAlertsCount : "9+";
    }
}

export default withRouter(observer(MainHeader));
